<div
  class="related-links-container"
  [style.borderLeft]="'2px solid ' + env['colors']['tool_btn_active']"
  [style.display]="screenSize > 1200 && shouldShow() ? 'block' : 'none'"
>
  <div class="related-links-content-container">
    <div
      [style]="
        'font-weight: bold; line-height: 26px; color:' +
        env['colors']['tool_btn_active']
      "
    >
      Related Links
    </div>
    <nav class="related-links-nav">
      @for (link of links; track link.title) {
        <a
          *ngIf="authService.hasPermission(link.tool_permission)"
          class="link-item"
          [style.color]="
            hoveringLink === link.tool_URL
              ? env['colors']['tool_btn_active']
              : 'black'
          "
          [routerLink]="link.tool_URL"
          (mouseenter)="hoveringLink = link.tool_URL"
          (mouseleave)="hoveringLink = ''"
          >{{ link.title }}</a
        >
      }
    </nav>
  </div>
</div>
